export default __webpack_public_path__ + "static/media/removal.22fe7be6.svg";